import { useCallback, useEffect, useState } from "react";

import { Popover } from "antd";
import styled from "styled-components";

import { BaseSlideToggle } from "components/base";
import {
  Info,
  InfoIconWrapper,
  InfoTitle
} from "components/user-settings/shared/SharedStyle";
import { useUserContext } from "components/user/context";
import { updateAutoZoomSetting } from "components/user/context/reducer/UserReducer";
import { useUserSettingMutation, useUserSettings } from "components/user/hooks";

import { AutoZoomSetting, DEFAULT_AUTO_ZOOM_SETTING } from "../../models";

const tooltipText = `By default, the dashboard will automatically zoom to the wells when well list is updated. This also applies to facilities list.
Disable to turn off this functionality.`;

const AutoZoomToggle = () => {
  // hooks
  const [, dispatch] = useUserContext();
  const { autoZoomSetting } = useUserSettings();
  const mutation = useUserSettingMutation<AutoZoomSetting>(DEFAULT_AUTO_ZOOM_SETTING);
  const [isAutoZoomEnabled, setIsAutoZoomEnabled] = useState<boolean>(
    autoZoomSetting?.isAutoZoomEnabled
  );

  const handleAutoZoomChange = useCallback(
    (autoZoomChange: boolean) => {
      mutation.mutate({
        id: autoZoomSetting?.id,
        isAutoZoomEnabled: autoZoomChange
      });
      setIsAutoZoomEnabled(autoZoomChange);
    },
    [autoZoomSetting?.id]
  );

  // Handle reload
  useEffect(() => {
    if (!mutation?.data?.id) return;
    updateAutoZoomSetting(dispatch, {
      id: mutation.data.id,
      isAutoZoomEnabled: mutation.data.isAutoZoomEnabled
    });
  }, [mutation?.data]);

  return (
    <Wrapper>
      <InfoTitle level={5} type="secondary">
        Auto Zoom on Well Input
        <Popover content={<Info>{tooltipText}</Info>} placement="right">
          <InfoIconWrapper />
        </Popover>
      </InfoTitle>
      <ToggleWrapper>
        <BaseSlideToggle
          checked={isAutoZoomEnabled}
          classic
          onChange={(val) => {
            handleAutoZoomChange(val);
          }}
        />
      </ToggleWrapper>
    </Wrapper>
  );
};

export default AutoZoomToggle;

//Styled  Components
const Wrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const ToggleWrapper = styled.div`
  position: relative;
  top: 3.5px;
`;
